import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal__title" };
const _hoisted_2 = { class: "report" };
const _hoisted_3 = {
    key: 0,
    class: "alert alert--error"
};
const _hoisted_4 = {
    key: 1,
    class: "alert alert--success"
};
const _hoisted_5 = { class: "report__header" };
const _hoisted_6 = { class: "report__title" };
const _hoisted_7 = { class: "report__content" };
const _hoisted_8 = { class: "table table--condensed" };
const _hoisted_9 = {
    key: 0,
    class: "report__content"
};
const _hoisted_10 = { class: "report__subtitle" };
const _hoisted_11 = { class: "table table--condensed" };
const _hoisted_12 = { class: "modal__footer" };
const _hoisted_13 = { class: "report-close" };
import { onMounted, ref } from 'vue';
import Modal from "@astina/paloma-common-ui/src/components/Modal.vue";
import ImportWatchlists from "../commands/ImportWatchlists";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistImportReportModal',
    props: {
        report: {}
    },
    emits: [
        'close'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const errors = ref(false);
        onMounted(() => errors.value = ImportWatchlists.hasErrors(props.report));
        function close() {
            emit('close');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, { onClose: close }, {
                header: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('watchlist.import_report')), 1)
                ]),
                content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        (errors.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('command.import_watchlists.error')), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('command.import_watchlists.success')), 1)),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.report.results, (sheet, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "report__sheet"
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("h3", _hoisted_6, _toDisplayString(sheet.sheetName), 1)
                                ]),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("table", _hoisted_8, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('watchlist.import_report.row')), 1),
                                            _cache[0] || (_cache[0] = _createTextVNode()),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('sku')), 1),
                                            _cache[1] || (_cache[1] = _createTextVNode()),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('orders.item_quantity')), 1),
                                            _cache[2] || (_cache[2] = _createTextVNode()),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('orders.item_portions_label')), 1),
                                            _cache[3] || (_cache[3] = _createTextVNode()),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('watchlist.import_report.operation')), 1)
                                        ]),
                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sheet.importRows, (row) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: row.row
                                            }, [
                                                _createElementVNode("td", null, _toDisplayString(row.row), 1),
                                                _cache[5] || (_cache[5] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(row.sku || '-'), 1),
                                                _cache[6] || (_cache[6] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(row.quantity || '-'), 1),
                                                _cache[7] || (_cache[7] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(row.portions || '-'), 1),
                                                _cache[8] || (_cache[8] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('watchlist.import_report.status.' + row.status)), 1),
                                                _cache[9] || (_cache[9] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('watchlist.import_report.operation.' + row.operation)), 1)
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                _cache[16] || (_cache[16] = _createTextVNode()),
                                (sheet.removals.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.$t('watchlist.import_report.removals')), 1),
                                        _cache[14] || (_cache[14] = _createTextVNode()),
                                        _createElementVNode("table", _hoisted_11, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('sku')), 1),
                                                _cache[11] || (_cache[11] = _createTextVNode()),
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('orders.item_quantity')), 1)
                                            ]),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sheet.removals, (removal, j) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: j }, [
                                                    _createElementVNode("td", null, _toDisplayString(removal.sku), 1),
                                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                                    _createElementVNode("td", null, _toDisplayString(removal.quantity), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("section", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("a", {
                                onClick: _withModifiers(close, ["prevent"]),
                                href: "",
                                class: "button"
                            }, _toDisplayString(_ctx.$t('close')), 1)
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
